module.exports = __webpack_public_path__ + "static/media/6.4fc674e6.png";